import { render, staticRenderFns } from "./DeleteList.vue?vue&type=template&id=38658000&scoped=true&"
import script from "./DeleteList.vue?vue&type=script&lang=js&"
export * from "./DeleteList.vue?vue&type=script&lang=js&"
import style0 from "./DeleteList.vue?vue&type=style&index=0&id=38658000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38658000",
  null
  
)

export default component.exports